import { EntityMetadataMap } from '@ngrx/data';
import { StateEntity } from './entity.constants';
import { ConversationStateModel, MessageStateModel } from './store-models';
import { UserDataModel } from '@modules/auth';

export const entityMetadata: EntityMetadataMap = {
  [StateEntity.User]: {
    selectId: (user: UserDataModel) => user.userId,
  },
  [StateEntity.Setting]: {
    selectId: (it) => it.id,
  },
  [StateEntity.Conversation]: {
    selectId: (it) => it.uniqueName,
    sortComparer: (a: ConversationStateModel, b: ConversationStateModel) =>
      Number(new Date(b.lastMessageDateCreated || b.dateCreated)) - Number(new Date(a.lastMessageDateCreated || a.dateCreated))
  },
  [StateEntity.Participant]: {
    selectId: (it) => it.sid,
  },
  [StateEntity.Message]: {
    selectId: (it) => it.sid,
    sortComparer: (a: MessageStateModel, b: MessageStateModel) => a.index - b.index
  },
};

const pluralNames = {};

export const entityConfig = {
  entityMetadata,
  pluralNames
};
